import { Text } from "@/components/text/Text";
import { useStyle } from "@/context/StyleContext";
import React from "react";

const ImageCard = ({
  source,
  title,
  onClick,
  noOverlay = false,
  innerContainerStyle,
  outerContainerStyle,
  imageStyle,
  imageOverlayStyle,
  noZoomEffect = false,
  maxWidth,
  noSourceText,
}: {
  source: any;
  noSourceText?: string;
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  noOverlay?: boolean;
  outerContainerStyle?: React.CSSProperties;
  innerContainerStyle?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
  imageOverlayStyle?: React.CSSProperties;
  noZoomEffect?: boolean;
  maxWidth?: string;
}) => {
  const { theme, colors } = useStyle();
  const [mouseOver, setMouseOver] = React.useState(false);

  return (
    <div
      onMouseOver={() => setMouseOver(true)}
      onMouseOut={() => setMouseOver(false)}
      style={{
        ...{
          aspectRatio: "1 / 1",
          position: "relative",
          overflow: "hidden",
          cursor: onClick ? "pointer" : "default",
          minWidth: "140px",
          maxWidth: maxWidth || undefined,
          flexGrow: 1,
        },
        ...outerContainerStyle,
      }}
      onClick={onClick}
    >
      <div
        style={{
          ...{
            transform: mouseOver && !noZoomEffect ? "scale(1.08)" : "scale(1)",
          },
          ...innerContainerStyle,
        }}
      >
        {source ? (
          <img
            src={source}
            alt="item"
            style={{
              ...{
                width: "100%",
                aspectRatio: "1 / 1",
                objectFit: "cover",
                transition: "transform 0.4s cubic-bezier(.4,2,.6,1)",
              },
              ...imageStyle,
            }}
          />
        ) : (
          <div
            style={{
              width: "100%",
              aspectRatio: "1 / 1",
              backgroundColor: "black",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {noSourceText && <Text type="p">{noSourceText}</Text>}
          </div>
        )}

        <div
          style={{
            ...{
              position: "absolute",
              width: "100%",
              aspectRatio: "1 / 1",
              top: 0,
              left: 0,
              backgroundColor: noOverlay
                ? "transparent"
                : `rgba(0, 0, 0, ${mouseOver ? 0.1 : 0.45})`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "opacity 0.3s ease-in-out",
            },
            ...imageOverlayStyle,
          }}
        >
          <Text
            containerStyle={{
              padding: "10px",
            }}
            style={{
              textAlign: "center",
              flexWrap: "wrap",
            }}
          >
            {title}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;
